import { isNode } from 'utils/environment';

export const sendEventToGA = (buttonName, action = 'CTA Click', category = 'Magazine') => // eslint-disable-line import/prefer-default-export
  window.ga?.('send', 'event', category, action, buttonName);

const GA_CHECK_INTERVAL = 500;
const GA_TIMEOUT_THRESHOLD = 20000;
export const checkGALoadedPromise = () =>
  new Promise((resolve, reject) => {
    // Don't run on the Node.js server
    if (isNode()) {
      resolve();
      return;
    }

    const timeStart = Date.now();

    function isLoaded() {
      if ('function' === typeof window.ga && 'object' === typeof window.dataLayer) {
        resolve();
        return;
      }

      const timeElapsed = Date.now() - timeStart;
      if (timeElapsed > GA_TIMEOUT_THRESHOLD) {
        reject(
          `ERROR: Google Analytics did not load within the timeout threshold of ${GA_TIMEOUT_THRESHOLD}ms`,
        );
        return;
      }

      setTimeout(isLoaded, GA_CHECK_INTERVAL);
    }

    isLoaded();
  });
